import { render, staticRenderFns } from "./seven.vue?vue&type=template&id=1b858088&scoped=true&"
var script = {}
import style0 from "./seven.vue?vue&type=style&index=0&id=1b858088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b858088",
  null
  
)

export default component.exports